import { GlButton, GlTooltipDirective } from '@gitlab/ui';
export default {
    name: 'DecisionLogHeaderButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        count: {
            type: Number,
            required: false,
            default: 0
        },
        isPanelOpen: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'open',
        'close'
    ],
    methods: {
        onClick () {
            this.$emit(this.isPanelOpen ? 'close' : 'open');
        }
    }
};
